import { useEffect } from "react";
import { EMessageTypes } from "src/types";

/**
 * Hook to send the widget height to the parent window via postMessage
 * The parent should listen for messages with type: 'setHeight'
 */
export const useSendHeightToParent = () => {
  useEffect(() => {
    const sendHeight = () => {
      const height = document.body.scrollHeight;

      window.parent.postMessage(
        {
          type: EMessageTypes.SetHeight,
          height: Math.max(height, 200),
        },
        "*"
      );
    };

    // Send initial height
    sendHeight();

    // Create ResizeObserver to watch for size changes
    const resizeObserver = new ResizeObserver(() => {
      sendHeight();
    });

    // Observe the entire document body for size changes
    resizeObserver.observe(document.body);

    // Also send height on window resize
    window.addEventListener("resize", sendHeight);

    // Cleanup
    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", sendHeight);
    };
  }, []);
};
